import React from "react";
import Helmet from "react-helmet";
import { Link } from "react-router";

const Error = () => {
  return(
    <div>
      <Helmet title="Fit My Kid: Page Not Found" />
      <div className="alert alert-danger">
        <p>Sorry, we couldn&apos;t find the page you requested.</p>
        <p>Were you looking for our <Link to="/">kids clothing size finder</Link>?</p>
        <p>If you aren&apos;t familiar with Fit My Kid, we recommend checking out our <a href="/welcome">welcome page</a></p>
      </div>
    </div>
  );
};

export default Error;



/** WEBPACK FOOTER **
 ** ./src/components/Error.js
 **/